import { Graphics, Sprite, Texture } from 'pixi.js';
import { Coords } from '../../../../elements/resource/types/shape.type';
import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
import gsap from 'gsap';
import { BackgroundService, GloveDefinition } from '../../background.service';

export class GloveElement {
  sprite: Sprite;
  constructor(
    private readonly bgService: BackgroundService,
    private readonly def: GloveDefinition,
    private readonly maskTarget?: Graphics | Sprite,
  ) {
    this.createGlow(def);
  }

  updatePosition(center: Coords) {
    this.def.center = center;
    this.sprite.position.set(center[0] * _screenX, center[1] * _screenY);
    // this.sprite.scale.set(1, 1);
  }
  private createGlow(g: GloveDefinition): Graphics | Sprite {
    // -- // -- // -- //
    // -- // -- // -- // -- // -- //
    const { color, alpha, center, radius, scale } = g;
    const canvas = document.createElement('canvas');
    const size = radius[0] * 2;
    canvas.height = size * 2;
    canvas.width = size * 2;

    const ctx = canvas.getContext('2d');
    const gradient = ctx.createRadialGradient(size, size, 0, size, size, size);
    gradient.addColorStop(0, `rgba(${this.hexToRgb(color)},${1})`);
    gradient.addColorStop(1, `rgba(${this.hexToRgb(color)},0)`);

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // -- // -- // -- // -- // -- // -- //
    const texture = Texture.from(canvas);
    this.sprite = new Sprite(texture);
    this.sprite.anchor.set(0.5);

    const [x, y] = center || [_screenX / 2, _screenY / 2];
    this.sprite.position.set(x * _screenX, y * _screenY);

    if (this.maskTarget) {
      this.sprite.mask = this.maskTarget;
    }
    // this.sprite.mask
    // -- // -- // -- // -- // -- // -- // -- //

    if (scale) {
      this.sprite.scale.set(scale[0], scale[1]);
    }

    return this.sprite;
  }

  hexToRgb(hex: string) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Parse shorthand (e.g. #03F) to full form (e.g. #0033FF) //
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `${r}, ${g}, ${b}`;
  }

  hide(duration: number) {
    const tl = gsap.timeline();
    tl.add(
      gsap.to(this.sprite, {
        duration,
        alpha: 0,
        ease: 'power4.inOut',
      }),
    );
    return tl;
  }

  keepMovingInterval: NodeJS.Timeout;
  dx = 0;
  dy = 0;
  gsapAnimate(duration: number, def: GloveDefinition, ease?: string) {
    const tl = gsap.timeline();
    const { center, scale: targetScale, from, after } = def;
    console.log('glove > gsapAnimate.init', def);
    console.log('from', from);
    //   currentX: this.sprite.position.x,
    //   tx: center[0] * _screenX,
    //   ty: center[1] * _screenY,
    //   startTime: tl.startTime(),
    // });
    // if (center[0] < 0) {
    //   return tl;
    // }
    if (center) {
      tl.add(
        gsap.to(this.sprite.position, {
          duration,
          x: center[0] * _screenX,
          y: center[1] * _screenY,
          ease: ease || 'power4.inOut',
          onStart: () => {
            console.log(
              'glove --------------- on-start > x',
              this.sprite.position.x,
            );

            this.dx = center[0] * _screenX - this.sprite.position.x;
            this.dy = center[1] * _screenY - this.sprite.position.y;
            const length = Math.sqrt(
              Math.pow(this.dx, 2) + Math.pow(this.dy, 2),
            );
            this.dx = this.dx / length;
            this.dy = this.dy / length;
            if (this.keepMovingInterval) {
              clearInterval(this.keepMovingInterval);
            }
          },
          onComplete: () => {
            console.log(
              'glove --------------- on-complete > x',
              this.sprite.position.x,
            );

            setInterval(() => {
              this.sprite.position.x += after?.[0] || this.dx;
              this.sprite.position.y += after?.[1] || this.dy;
            }, 10);
          },
        }),
      );
    }

    if (targetScale) {
      tl.add(
        gsap.to(this.sprite.scale, {
          duration,
          x: targetScale[0],
          y: targetScale[1],
          ease: ease || 'power4.inOut',
        }),
      );
    }

    return tl;
  }
}
